(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    // Clicking the stars opens the collapsible row with the Judge.me reviews and scrolls to it
  if (!window.ratingLinkReady) {
    window.ratingLinkReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-open-reviews]');
      if (!link) return;

      const widget = document.querySelector('[id*="judge_me_reviews_review_widget"], .jdgm-horizon-widget');
      const details = widget?.closest('details');
      if (!details) return;

      event.preventDefault();
      details.open = true;

      // Leave room for the sticky header so the row is not hidden behind it
      const header = document.querySelector('header-component');
      const headerBottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
      const top = details.getBoundingClientRect().top + window.scrollY - headerBottom - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide-link"] && !Shopify.designMode) return;
  try {
    // Clicking the link opens the «Finn din størrelse» collapsible row and scrolls to it
  if (!window.sizeGuideLinkReady) {
    window.sizeGuideLinkReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-open-size-guide]');
      if (!link) return;

      const details = document.querySelector('.size-chart__details');
      if (!details) return;

      event.preventDefault();
      details.open = true;

      // Leave room for the sticky header so the row is not hidden behind it
      const header = document.querySelector('header-component');
      const headerBottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
      const top = details.getBoundingClientRect().top + window.scrollY - headerBottom - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
